import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=f0bce6d2&scoped=true"
import script from "./TaskManage.vue?vue&type=script&lang=js"
export * from "./TaskManage.vue?vue&type=script&lang=js"
import style0 from "./TaskManage.vue?vue&type=style&index=0&id=f0bce6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bce6d2",
  null
  
)

export default component.exports